"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _typography = _interopRequireDefault(require("typography"));

var _styledComponents = require("styled-components");

var _polished = require("polished");

var _theme = _interopRequireWildcard(require("../theme"));

var _utilities = require("../Modules/Layer/utilities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var SliceProvider =
/** @class */
function (_super) {
  (0, _tslib.__extends)(SliceProvider, _super);

  function SliceProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.displayName = 'SliceProvider';
    _this.nz = (0, _polished.normalize)();
    _this.baseTypography = new _typography.default(_theme.typography).toString();
    return _this;
  }

  SliceProvider.prototype.componentDidMount = function () {
    (0, _utilities.createLayerPortalNode)();
  };

  SliceProvider.prototype.render = function () {
    var GlobalStyle = (0, _styledComponents.createGlobalStyle)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n      ", "\n      ", "\n    "], ["\n      ", "\n      ", "\n    "])), _theme.fontDefinitions, !this.props.disableGlobal && "" + this.nz + _theme.global + this.baseTypography);
    return React.createElement(_styledComponents.ThemeProvider, {
      theme: _theme.default
    }, React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), this.props.children));
  };

  return SliceProvider;
}(React.PureComponent);

var _default = SliceProvider;
exports.default = _default;
var templateObject_1;